module.exports = __webpack_public_path__ + "media/2022/heart-1bab03a5.png";